<template>
  <div class="tab">
    <div class="content">
      <div class="item" v-for="(item, key) in list" :class="key === index ? 'active':''">
        <div class="name">{{item.name}}</div>
        <div class="border"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    index: Number,
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .tab{
    padding-top: 43px;



    .content{
      width: 800px;
      border-bottom: 1px solid #C4C4C4;
      display: flex;

      .item{
        font-size: 24px;
        color: rgba(255,255,255,0.8);
        margin-right: 180px;
        .border{
          width: 60px;
          height: 7px;
          background: none;
          margin-top: 20px;
        }
      }
      .item.active{
        font-size: 30px;
        color: #EB6100;
        font-weight: 500;
        .border{
          background: #EB6100;
        }
      }
    }

  }
</style>
